<script setup lang="ts">
    import './index.scss';

    const props = defineProps({
        inputName: {
            type: String,
            default: 'text', 
        },
        model: {
            type: [Array, String],
        },
        type: {
            type: String as PropType<'search' | 'default'>,
            default: 'default',
            required: false,
        },
        disabled: {
            type: Boolean,
            required: false
        },
        icon: {
            type: String,
            default: '',
            required: false,
        },
        multiple: {
            type: Boolean,
            required: false
        },
        class: {
            type: String,
            required: false
        },
        placeholder: {
            type: String,
            defaultValue: '',
            required: false
        }
    })

    const optionsList = computed(() => props.model)
    const classObject = computed(() => ({
        'rounded-none' : props.type == 'default',
        'rounded-[0.8rem] border-[lightGray] border-solid border-[1px] h-[5.3rem] max-md:h-[4rem]' : props.type == 'search',
    }))

    const updateValue = (event: any) => {
        const value = (event === undefined) ? null : { label: event.label, value: event.key };
        setValue(value);
        emit('change', value);
    };

    const emit = defineEmits(['change']);

    const { value, setValue, errorMessage }: any = useField(props.inputName)
</script>

<template>
    <Block 
        :class="[
            'relative flex flex-col',
            props.class
        ]"
    >
        <Block class="relative flex w-full">
            <CustomIcon
                v-if="props.icon !== ''"
                class="absolute top-[50%] left-[1rem] translate-y-[-50%] w-[1rem] h-[1rem] text-[1.4rem] z-10 ant-select-suffix"
                :name="props.icon"
            />
            <a-select 
                :class="[
                    { 'is-invalid' : errorMessage },
                    'w-full dropdown text-[1.4rem] font-bold text-[darkGray] placeholder-[darkGray] shadow border-lightGray border-solid border-[1px]', 
                    { 'with-icon' : props.icon !== '' },
                    classObject, 
                    props.class,
                ]"
                :id="props.inputName"
                :name="props.inputName"
                :disabled="props.disabled"
                :mode="props.multiple ? 'multiple' : undefined"
                :options="optionsList as any"
                :labelInValue="true"
                :placeholder="props.placeholder"
                :allowClear="true"
                :value="value"
                @change="updateValue">
            </a-select>
        </Block>
        <template v-if="errorMessage">
            <p class="text-[redError] text-[1.4rem] leading-[1.5] mt-[.4rem]">
            {{  errorMessage }}
            </p>
        </template>
    </Block>
</template>